import _taggedTemplateLiteral from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    query HeaderConfiguration($domain: String!) {\n  configuration {\n    header(input: {domain: $domain}) {\n      meta {\n        salesChannel {\n          code\n        }\n      }\n      topHeader {\n        leftSection {\n          name\n          url\n          icon\n          iconSize\n        }\n        rightSection {\n          name\n          url\n          icon\n          iconSize\n        }\n      }\n      primaryHeader {\n        logo {\n          imageSrc\n          alt\n          url\n          enabled\n          condensedImageSrc\n        }\n        searchBar {\n          enabled\n        }\n        club {\n          enabled\n          clubCatchTileEnabled\n        }\n        clubFlybuys {\n          enabled\n        }\n        cart {\n          enabled\n        }\n        flybuys {\n          enabled\n        }\n        wishlist {\n          enabled\n        }\n        myAccount {\n          enabled\n          showFlybuysLink\n        }\n        userLocation {\n          enabled\n        }\n      }\n      headerTheme\n      megaMenu {\n        enabled\n        navData {\n          shops {\n            id\n            slug\n            name\n            url\n            pinToTop\n            shopNavigationGroups {\n              id\n              slug\n              name\n              url\n              shopNavigationItems {\n                id\n                slug\n                name\n                url\n              }\n            }\n            topBrands {\n              id\n              slug\n              name\n              url\n            }\n          }\n          catchEssentialsMenu {\n            giftCards\n            catchMobile\n          }\n          accountMenu {\n            loggedInMenu {\n              name\n              url\n            }\n            loggedOutMenu {\n              name\n              url\n            }\n          }\n        }\n      }\n    }\n  }\n}\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    query FooterData {\n  footer {\n    navigationLinkColumns {\n      columnTitle\n      links {\n        text\n        url\n        openInNewWindow\n      }\n    }\n    appDownloadLinks {\n      name\n      url\n    }\n    copyright\n  }\n}\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// @ts-ignore

/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export var FooterDataDocument = gql(_templateObject());
/**
 * __useFooterDataQuery__
 *
 * To run a query within a React component, call `useFooterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFooterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFooterDataQuery({
 *   variables: {
 *   },
 * });
 */

export function useFooterDataQuery(baseOptions) {
  return Apollo.useQuery(FooterDataDocument, baseOptions);
}
export function useFooterDataLazyQuery(baseOptions) {
  return Apollo.useLazyQuery(FooterDataDocument, baseOptions);
}
export var HeaderConfigurationDocument = gql(_templateObject2());
/**
 * __useHeaderConfigurationQuery__
 *
 * To run a query within a React component, call `useHeaderConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderConfigurationQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */

export function useHeaderConfigurationQuery(baseOptions) {
  return Apollo.useQuery(HeaderConfigurationDocument, baseOptions);
}
export function useHeaderConfigurationLazyQuery(baseOptions) {
  return Apollo.useLazyQuery(HeaderConfigurationDocument, baseOptions);
}